import type { ElementRef } from '@angular/core';
import { Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { XlsxToJsonService } from '../../shared/services/xlsx-to-json.service';

@Component({
  standalone: false,
  selector: 'invd-fm-xlsx-json',
  templateUrl: './fm-xlsx-json.component.html',
  styleUrls: ['./fm-xlsx-json.component.scss'],
})
export class FmXlsxJsonComponent {
  public result: any = [];
  //  = new XlsxToJsonService();

  public alert: any = [];
  public msgs: any = [];
  public uploadedFiles: any;

  focus: boolean;
  files: any;
  showError = false;

  @Input() buttonLabel = 'Choose';
  @Input() displayLabel = 'Select an .xlsx or .csv file to get json';
  @Input() style: string;
  @Input() styleClass: string;
  @Input() showJson = false;
  @Input() stringFormat = false;
  @Input() multiple = false;
  @Input() successMsg = true;
  @Input() headers: Array<string>;
  @Output() showFileName: EventEmitter<any> = new EventEmitter();
  @Output() conversion: EventEmitter<any> = new EventEmitter();
  @Output() sheetsNameWithColumnCount: EventEmitter<any> = new EventEmitter();
  @Output() showFileExtensionError: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('fileinput', { static: true }) fileInput: ElementRef;
  @Output() showIsFileCorrupted: EventEmitter<any> = new EventEmitter();
  @Output() getExcelSheetsContent: EventEmitter<any> = new EventEmitter();

  private xlsxToJsonService = inject(XlsxToJsonService);

  handleFile(event) {
    this.uploadedFiles = Array.from(event.target.files);
    const fileName = event.target.files[0].name;
    this.uploadedFiles.forEach((element, index) => {
      const validExts = ['.xlsx', '.xls'];
      let fileExt = event.target.value;
      fileExt = fileExt && fileExt.slice(Math.max(0, fileExt.lastIndexOf('.')));
      if (!validExts.includes(fileExt)) {
        this.clear();
        this.alert = [];
        this.alert.push({
          type: 'error',
          message: 'Invalid file selected, valid files are of ' + validExts.toString() + ' types.',
        });
        this.showError = true;
        this.showFileExtensionError.emit(true);
        return false;
      }
      this.xlsxToJsonService.processFileToJson({}, element, this.headers).subscribe((data) => {
        if ((this.multiple && index === this.uploadedFiles.length - 1) || !this.multiple) {
          if (this.multiple) {
            this.result = this.stringFormat
              ? JSON.stringify([...this.result, ...data.sheets], null, '\t')
              : [...this.result, ...data.sheets];
          } else {
            this.result = this.stringFormat ? JSON.stringify(data.sheets, null, '\t') : data.sheets;
          }
        } else {
          this.result = [...this.result, ...data.sheets];
        }
        // this.result =this.multiple? this.result.concat(fnlResult): fnlResult;
        if ((this.multiple && index === this.uploadedFiles.length - 1) || !this.multiple) {
          if (this.result) {
            const sheetsNameWithColumnCount = this.xlsxToJsonService.getSheetsNameWithColumnCount();
            const getExcelSheetsContent = this.xlsxToJsonService.getExcelContent();
            this.showFileName.emit({ fileName });
            this.sheetsNameWithColumnCount.emit({
              sheetsNameWithColumnCount,
            });
            this.getExcelSheetsContent.emit({ getExcelSheetsContent });
            this.conversion.emit({ json: this.result });
            this.showIsFileCorrupted.emit(this.xlsxToJsonService.getIsFileCOrrupted());
            this.msgs = [];
            this.msgs.push({
              type: 'success',
              summary: 'Success Message',
              message: 'Excel to JSON conversion is done',
            });
          } else {
            this.showError = true;
            this.alert = [];
            this.alert.push({ type: 'error', message: 'Unsupported file' });
          }
        }
      });
    });
  }

  clear() {
    this.files = [];
    this.result = [];
    this.clearInputElement();
  }

  clearInputElement() {
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  onFocus() {
    if (this.result) {
      this.clear();
    }
    this.focus = true;
  }

  onBlur() {
    this.focus = false;
  }
}
